import { render, staticRenderFns } from "./RwDriverEdit.vue?vue&type=template&id=1169fcb2&scoped=true"
import script from "./RwDriverEdit.vue?vue&type=script&lang=ts"
export * from "./RwDriverEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1169fcb2",
  null
  
)

export default component.exports